import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

import HRule from '../../atoms/HRule'
import CallToSell from '../../organisms/CallToSell'
import CallToBuy from '../../organisms/CallToBuy'
import EmailVerified from '../../molecules/EmailVerified'
import VerifyEmailLinkExpired from '../../molecules/VerifyEmailLinkExpired'
import medias from '../../../util/medias'
import Lurker from '../../../util/lurker'
import behaviors from '../../../util/behaviors'
import validateEmailApiCall from './api'

const lurker = new Lurker('email_validation')

// prettier-ignore
const Content = styled(View)`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Row = styled(View)`
  flex: 1;
  display: flex;
  flex-direction: row;
  padding-bottom: 32px;
  ${medias.extraLarge`flex-direction: column;`}
`

const HRuleWrapper = styled(View)`
  width: 100%;
  margin-top: 24px;
  margin-right: 0;
  margin-bottom: 24px;
  margin-left: 0;
`

const CallToSellWrapper = styled(View)`
  ${medias.extraLarge`margin-bottom: 64px;`}
`

const EmailVerifiedWrapper = styled(View)`
  width: 70%;
  ${medias.extraLarge`width: 100%;`}
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
`

export class EmailValidationTemplate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isExpired: false,
      isVerified: false,
    }
  }

  componentDidMount() {
    lurker.pageLoadEvt()
    this.validateEmail()
  }

  validateEmail() {
    const { token, onSuccess, onExpiredLink } = this.props
    validateEmailApiCall(token)
      .then(() => {
        lurker.viewMessageEvt('validation_success')
        this.setState({ isVerified: true }, onSuccess)
      })
      .catch(error => {
        const { response: { status = '' } = {} } = error || {}
        if (status === 410) {
          lurker.viewMessageEvt('error', {
            accounts_reason: 'expired_link',
            accounts_status_code: status,
          })
          this.setState({ isExpired: true }, onExpiredLink)
        } else if (status) {
          lurker.viewMessageEvt('error', {
            accounts_reason: 'unexpected_status_code',
            accounts_status_code: status,
          })
          behaviors.goToErrorPage(`ErrorExchangingToken${status}`)
        } else {
          lurker.viewMessageEvt('error', {
            accounts_reason: 'unexpected_error',
            accounts_error_message: (error && error.message) || 'unknown',
          })
          behaviors.goToErrorPage('UnexpectedErrorExchangingToken')
        }
      })
  }

  renderEmailVerified() {
    const { onMyAccountClick } = this.props
    return (
      <EmailVerifiedWrapper>
        <EmailVerified onMyAccountClick={onMyAccountClick} />
        <HRuleWrapper>
          <HRule />
        </HRuleWrapper>
        <Row>
          <CallToSellWrapper>
            <CallToSell onClick={() => lurker.clickEvt('insert_now')} />
          </CallToSellWrapper>
          <CallToBuy onClick={() => lurker.clickEvt('see_offers')} />
        </Row>
      </EmailVerifiedWrapper>
    )
  }

  renderLinkExpired() {
    const { onMyAccountClick } = this.props
    return <VerifyEmailLinkExpired onMyAccountClick={onMyAccountClick} />
  }

  render() {
    const { isVerified, isExpired } = this.state
    return (
      <Content>
        {isVerified && this.renderEmailVerified()}
        {isExpired && this.renderLinkExpired()}
      </Content>
    )
  }
}

EmailValidationTemplate.propTypes = {
  token: PropTypes.string,
  onMyAccountClick: PropTypes.func,
  onSuccess: PropTypes.func,
  onExpiredLink: PropTypes.func,
}
